import React from 'react';
import { Spinner } from 'react-bootstrap';
import { C } from '../utils/constants';
import { fmtUnit, fmtLabel } from '../utils/helpers';

// unit : respecte le sélecteur d'unité de la section parente
const BarChart = ({ labels, realise, budget, loading, color1, color2, labelR = 'Réalisé', labelB = 'Budget', unit }) => {
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 220 }}>
      <Spinner />
    </div>
  );
  if (!labels?.length) return (
    <div style={{ textAlign: 'center', color: '#aaa', padding: '40px 0', fontSize: '0.85rem' }}>
      Aucune donnée sur la période
    </div>
  );

  const c1 = color1 || C.bar1;
  const c2 = color2 || C.bar2;
  const maxVal = Math.max(...realise, ...budget, 1);

  const PL = 10, PR = 10, PT = 28, PB = 28;
  const n = labels.length;
  const groupW = Math.max(44, Math.min(90, Math.floor(560 / (n + 1))));
  const barW = Math.max(8, Math.floor(groupW * 0.35));
  const gap = Math.max(2, Math.floor(barW * 0.25));
  const W = PL + n * groupW + PR;
  const chartH = 140;
  const H = PT + chartH + PB;

  const xGroup = (i) => PL + i * groupW + groupW / 2;
  const barH = (v) => Math.max(2, (v / maxVal) * chartH);

  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} style={{ display: 'block', minWidth: W }}>
        <rect x={0} y={0} width={W} height={H} fill="#ffffff" />
        <rect x={PL} y={6} width={10} height={10} rx={2} fill={c1} />
        <text x={PL + 14} y={15} fontSize={9} fill="#666" fontFamily="sans-serif" fontWeight="600">{labelR}</text>
        <rect x={PL + 90} y={6} width={10} height={10} rx={2} fill={c2} />
        <text x={PL + 104} y={15} fontSize={9} fill="#666" fontFamily="sans-serif" fontWeight="600">{labelB}</text>
        <line x1={PL} y1={PT + chartH} x2={W - PR} y2={PT + chartH} stroke="#e0e0e0" strokeWidth={1} />
        {labels.map((lbl, i) => {
          const cx = xGroup(i);
          const hR = barH(realise[i] || 0);
          const hB = barH(budget[i]  || 0);
          return (
            <g key={lbl}>
              <rect x={cx - gap / 2 - barW} y={PT + chartH - hR} width={barW} height={hR} rx={2} fill={c1}>
                <title>{`${labelR}: ${fmtUnit(realise[i], unit)}`}</title>
              </rect>
              <rect x={cx + gap / 2} y={PT + chartH - hB} width={barW} height={hB} rx={2} fill={c2}>
                <title>{`${labelB}: ${fmtUnit(budget[i], unit)}`}</title>
              </rect>
              <text x={cx} y={PT + chartH + 16} textAnchor="middle" fontSize={8} fill="#999" fontFamily="sans-serif">
                {fmtLabel(lbl)}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
};

export default BarChart;
